import { useParams, Navigate } from "react-router-dom";
import { getPageComponent } from "@/reports/registry";

export default function DemoReportEditor() {
  const { reportType } = useParams();
  const Page = getPageComponent(reportType);

  if (!Page) return <Navigate to="/demo" replace />;

  return <Page />;
}
